import { apiClient } from 'client/core/network/apiClient';
import {
  ICitizenActivateDto,
  ICitizenCreateAccessTokenDto,
  ICitizenEditDto,
  ICitizenRegisterDto,
  ICitizenRequestResetDto,
  ICitizenResetDto
} from 'common/dto/CitizenDto';
import { PaginatedResult } from 'common/dto/shared/PaginatedResult';
import { IUser } from 'common/schema/User';

export const CitizenApi = {
  register: (opts: { input: ICitizenRegisterDto }) =>
    apiClient.post<IUser>(`/citizens`, opts.input),
  update: (opts: { input: ICitizenEditDto }) =>
    apiClient.post<IUser>(`/citizens/actions/update`, opts.input),
  activate: (opts: { input: ICitizenActivateDto }) =>
    apiClient.post<void>(`/citizens/actions/activate`, opts.input),
  requestReset: (opts: { input: ICitizenRequestResetDto }) =>
    apiClient.post<void>(`/citizens/actions/request-reset`, opts.input),
  reset: (opts: { input: ICitizenResetDto }) =>
    apiClient.post<void>(`/citizens/actions/reset`, opts.input),
  addEmail: (opts: { input: { token: string; email: string } }) =>
    apiClient.post<void>('/citizens/actions/add-email', opts.input),

  /** Creazione dell'access token per il login. Il refresh viene gestito da AuthApi */
  createAccessToken: (data: ICitizenCreateAccessTokenDto) =>
    apiClient.post('/citizens/auth/access-token', data)
};
